import { CheckCircleIcon, CircleAlertIcon, CrossIcon } from '../../Icons';
import { closeButtonVariants, toastVariants } from '../logic';
import styles from './styles.module.scss';

type StatusType = 'success' | 'danger';

type Props = {
  /** 表示するテキスト */
  message: string;
  /** 表示する種類 */
  status?: StatusType;
  /** 閉じるボタンをクリックした時のイベントハンドラー */
  onClickClose?: () => void;
  /** 閉じるボタンをクリックした時のanimationフラグ */
  isClosing: boolean;
};

export const ToastPresentation: React.FC<Props> = ({
  message,
  status = 'success',
  onClickClose,
  isClosing,
  ...props
}) => {
  const isSuccessed = status === 'success';

  const wrapperClasses = toastVariants({ status });
  const buttonClasses = closeButtonVariants({ status });

  return (
    <div className={`${wrapperClasses} ${isClosing ? styles.closing : ''}`} {...props}>
      {isSuccessed ? <CheckCircleIcon size='xs' /> : <CircleAlertIcon size='xs' />}
      <span className={styles.message}>{message}</span>
      {onClickClose && (
        <button className={buttonClasses} onClick={onClickClose} type='button'>
          <CrossIcon size='xs' />
        </button>
      )}
    </div>
  );
};
